
import React, { Component } from "react";
import { connect } from "react-redux";
import { customerService } from "../../services";
import axios from "axios";
import "./Upspiration.scss";

class Upspiration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null, // 'authorized' | 'redeemed' | 'notfound'
            showCodeModal: false, // ควบคุมการแสดงโมดัลกรอกรหัส
            codeDigits: ["", "", "", ""], // เก็บเลขแต่ละช่อง
            amwayNumber: null,
            partyId: null,
        };
    }

    componentDidMount() {
        this.checkCustomer();
    }

    componentDidUpdate(prevProps) {
        if (this.props.profile.userId !== prevProps.profile.userId) {
            this.checkCustomer();
        }
    }

    checkCustomer() {
        const { profile } = this.props;
        if (!profile?.userId) return;

        customerService
            .get(profile.userId)
            .then((res) => {
                if (res && res._id && ["abo", "member"].includes(res.type)) {
                    this.setState({
                        amwayNumber: res.amwayNumber,
                        partyId: res.partyId,
                    });
                    return axios.post(
                        `${process.env.REACT_APP_API_URL}/customers/upspiration`,
                        {
                            uid: profile.userId,
                            amwayNumber: res.amwayNumber,
                            partyId: res.partyId,
                        }
                    );
                } else {
                    this.setState({ status: "notfound" });
                }
            })
            .then((response) => {
                if (!response) return;
                const data = response.data;
                if (data === "คุณได้รับสิทธิ์") {
                    this.setState({ status: "authorized" });
                } else if (data === "คุณใช้งานไปแล้ว") {
                    this.setState({ status: "redeemed" });
                } else {
                    this.setState({ status: "notfound" });
                }
            })
            .catch(() => {
                this.setState({ status: "notfound" });
            });
    }

    handleConfirm = () => {
        this.setState({ showCodeModal: true }, () => {
            if (this.digit0) {
                this.digit0.focus();
            }
        });
    };

    // ปิดโมดัล
    handleCancelCode = () => {
        this.setState({ showCodeModal: false, codeDigits: ["", "", "", ""] });
        if (window.liff && typeof window.liff.closeWindow === "function") {
            window.liff.closeWindow();
        } else {
            // เบราว์เซอร์ทั่วไป
            window.close();
        }
    };
    // อัปเดตเลขแต่ละช่อง
    handleDigitChange = (idx, e) => {
        const v = e.target.value.replace(/\D/, "").slice(-1);
        const code = [...this.state.codeDigits];
        code[idx] = v;
        this.setState({ codeDigits: code }, () => {
            // ถ้ากรอกครบ จะโฟกัสช่องถัดไปอัตโนมัติ
            if (v && idx < 3) {
                this[`digit${idx + 1}`].focus();
            }
        });
    };

    // ส่งรหัสไปตรวจสอบหรือแลกของรางวัล
    handleSubmitCode = () => {
        const code = this.state.codeDigits.join("");
        const { profile } = this.props;
        const { amwayNumber, partyId } = this.state;

        axios.post(
            `${process.env.REACT_APP_API_URL}/customers/upspiration_update`,
            {
                uid: profile.userId,
                amwayNumber: amwayNumber,
                partyId: partyId,
                user: code,
            }
        )
            .then((res) => {
                const msg = res.data;
                // อัปเดต status ตามที่ backend ส่งกลับ
                if (msg === "คุณได้รับสิทธิ์") {
                    this.setState({ status: "redeemed" });
                } else if (msg === "คุณใช้งานไปแล้ว") {
                    this.setState({ status: "redeemed" });
                } else if (msg === "สถานะข้อมูลไม่ชัดเจน") {
                    this.setState({ status: "authorized" });
                } else {
                    this.setState({ status: "notfound" });
                }
            })
            .catch((err) => {

                this.setState({ status: "notfound" });
            })
            .finally(() => {
                // ปิด modal และรีเซ็ต codeDigits ทุกกรณี
                this.setState({ showCodeModal: false, codeDigits: ["", "", "", ""] });
            });
    };

    handleClose = () => {
        if (window.liff && typeof window.liff.closeWindow === "function") {
            window.liff.closeWindow();
        } else {
            // เบราว์เซอร์ทั่วไป
            window.close();
        }
    };

    renderCodeModal() {
        const { codeDigits } = this.state;
        return (
            <div className="modalOverlay">
                <div className="modalBox">
                    <p className="modalTitle">
                        ระบุรหัสสำหรับการแลกของรางวัล
                    </p>
                    <p className="modalSubtitle">
                        กรุณาให้เจ้าหน้าที่เป็นผู้กรอกรหัสและกดแลกของรางวัล
                    </p>
                    <div className="codeRow">
                        {codeDigits.map((d, i) => (
                            <input
                                key={i}
                                ref={(ref) => (this[`digit${i}`] = ref)}
                                type="password"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={1}
                                value={d}
                                onChange={(e) => this.handleDigitChange(i, e)}
                                onKeyDown={(e) => {
                                    if (e.key === "Backspace" && !e.target.value && i > 0) {
                                        if (this[`digit${i - 1}`]) { this[`digit${i - 1}`].focus(); }
                                    }
                                }}
                                className="codeInput"
                            />
                        ))}
                    </div>
                    <div className="modalActions">
                        <div className="btnContainer">
                            <button
                                className="btnOverlayCancel"
                                onClick={this.handleCancelCode}
                            />
                            <button
                                className="btnOverlaySubmit"
                                onClick={this.handleSubmitCode}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderHeader() {
        return (
            <div className="headerBar">
                <span className="headerText">Upspiration</span>
            </div>
        );
    }

    renderAuthorized() {
        return (
            <div className="upspiration fullscreen">
                {this.renderHeader()}
                <div className="containerAuthorized">
                    <div className="content">
                        <div className="giftInfo">
                            <p className="giftLine">
                                รับฟรี! Amway Crossbody Bag (มี 2 สีให้เลือก)**
                            </p>
                            <p className="giftLine">
                                และ นิวทรีไลท์ วิตามินบี พลัส ชนิดซอง
                            </p>
                            <p className="giftNote">
                                (รหัสละ 1 ชุด, รวมมูลค่า 370 บาท)
                            </p>
                        </div>
                        <div className="detailBox">
                            <p className="conditionTitle">
                                เงื่อนไขการรับของรางวัล:
                            </p>
                            <ul className="rulesList">
                                <li>
                                    กรุณาแสดงหน้านี้ที่เจ้าหน้าที่ประจำบูธ <span style={{ color: "red" }}>โซนธุรกิจ</span>
                                </li>
                                <li>
                                    และให้เจ้าหน้าที่เป็นผู้กดยืนยันเพื่อรับสิทธิ์
                                </li>
                                <li>
                                    หากกดยืนยันรับของรางวัล
                                    ระบบจะบันทึกว่าท่านได้รับสิทธิ์แล้ว
                                    และไม่สามารถยืนยันซ้ำได้
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="confirmButtonWrapper">
                        <div className="confirmNote">
                            ให้เจ้าหน้าที่แอมเวย์เป็นผู้ยืนยันเท่านั้น
                        </div>
                        <button
                            className="confirmButton"
                            onClick={this.handleConfirm}
                        >
                            ยืนยันการรับรางวัล
                        </button>
                    </div>
                    {this.state.showCodeModal && this.renderCodeModal()}
                </div>
            </div>
        );
    }

    renderRedeemed() {
        return (
            <div className="upspiration fullscreen">
                <div className="containerRedeemed">
                    <button
                        className="closeButton"
                        onClick={this.handleClose}
                    >
                        ✕
                    </button>

                </div>
            </div>
        );
    }

    renderNotFound() {
        return (
            <div className="upspiration fullscreen">
                {this.renderHeader()}
                <div className="containerNotFound">
                    <div className="contentNotFound">
                        <div className="detailBox">
                            <p className="conditionTitle">
                                เงื่อนไขสำหรับผู้มีสิทธิ์รับของรางวัล:
                            </p>
                            <ul className="rulesList">
                                <li>
                                    นักธุรกิจใหม่ที่สมัครตั้งแต่วันที่ 24
                                    พฤษภาคม 2568 เป็นต้นไป
                                </li>
                                <li>
                                    สมาชิกที่มีการอัปเกรดสถานะ ตั้งแต่วันที่ 24
                                    พฤษภาคม 2568 เป็นต้นไป
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button
                        className="confirmButtonNotfound"
                        onClick={this.handleClose}
                    >
                        กลับสู่บริการหลัก
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { status } = this.state;
        return (
            <>
                {/* ฝัง CSS ซ่อน spin-button */}
                <style></style>

                {status === "authorized" && this.renderAuthorized()}
                {status === "redeemed" && this.renderRedeemed()}
                {status === "notfound" && this.renderNotFound()}
            </>
        );
    }
}



const mapStateToProps = (state) => ({
    profile: state.profile,
});

export default connect(mapStateToProps)(Upspiration);


